import { SET_UBICACION } from "../ActionTypes";

export const setUbicacion = (payload) => (dispatch) => {
    dispatch({type:SET_UBICACION, payload}); 
}; 